import React, { Component } from "react";
import HeadDetails from "../components/HeadDetails";
import CoordDetails from "../components/CoordDetails";
import Stavan from "../assets/images/team/overall_head.jpg";
import Krati from "../assets/images/team/krati_core.jpg";
import Ashutosh from "../assets/images/team/ashutosh_tiwari_core.jpg";
import Dhananjay from "../assets/images/team/dhananjay_core.jpg";
import HariOm from "../assets/images/team/hari_om_singh_core.jpg";
import Adyasa from "../assets/images/team/adyasa_core.jpg";
import Mahesh from "../assets/images/team/sai_mahesh_core.jpg";
import Sharanya from "../assets/images/team/sharanya_core.jpg";
import Nikhil from "../assets/images/team/y_m_nikhil_core.jpg";
import "../assets/styles/team.scss";
//import {Placeholder} from 'semantic-ui-react';
import { Header } from "semantic-ui-react";
import AOS from "aos";
import "aos/dist/aos.css";
import {withUserContext} from "../components/ModalContext";

class Team extends Component {
  constructor(props) {
    super(props);
    this.overall_head = {
      name: "Stavan Christian",
      number: 9974017449,
      email: "stavan@elan.org.in",
      photo: Stavan,
      animation: "fade-down",
    };

    this.heads = [
      {
        name: "Krati Arela",
        number: 6265534713,
        email: "krati@elan.org.in",
        photo: Krati,
        domain: "Public Relations",
        animation: "fade-right",
      },
      {
        name: "Ashutosh Tiwari",
        number: 9876543210,
        email: "ashutosh.t@elan.org.in",
        photo: Ashutosh,
        domain: "Sponsorship",
        animation: "fade-down",
      },
      {
        name: "Dhananjay Singh",
        number: 8209039553,
        email: "finance.head@elan.org.in",
        photo: Dhananjay,
        domain: "Finance",
        animation: "fade-down",
      },
      {
        name: "Hari Om Singh",
        number: 7897942457,
        email: "hariom.s@elan.org.in",
        photo: HariOm,
        domain: "Hospitality",
        animation: "fade-left",
      },
      {
        name: "Adyasa Mohanty",
        number: 8457097003,
        email: "adyasa.m@elan.org.in",
        photo: Adyasa,
        domain: "Proshows",
        animation: "fade-right",
      },
      {
        name: "Y M Nikhil",
        number: 7093552503,
        email: "nikhil.y@elan.org.in",
        photo: Nikhil,
        domain: "Creatives",
        animation: "fade-down",
      },
      {
        name: "Sharanya Reddy",
        number: 9381411880,
        email: "sharanya@elan.org.in",
        photo: Sharanya,
        domain: "Culti",
        animation: "fade-down",
      },
      {
        name: "Sai Mahesh",
        number: 9381306441,
        email: "mahesh.s@elan.org.in",
        photo: Mahesh,
        domain: "Techy",
        animation: "fade-left",
      },
    ];

    this.coords = [
      {
        domain: "Web",
        coords: [
          {
            name: "Brijesh Aghav",
            number: 8698488688,
          },
          {
            name: "Nandita LT",
            number: 9030035700,
          },
          {
            name: "Samar Garg",
            number: 9888861650,
          },
        ],
      },
      {
        domain: "PR",
        coords: [
          {
            name: "Shree Varsha",
            number: 9543037637,
          },
          {
            name: "Ashish",
            number: 9247858685,
          },
          {
            name: "Smaran",
            number: 7995204145,
          },
        ],
      },
      {
        domain: "Publicity",
        coords: [
          {
            name: "Vivek VK",
            number: 9390167455,
          },
          {
            name: "Sai Venkat",
            number: 9553366368,
          },
          {
            name: "Charitha",
            number: 9390123341,
          },
        ],
      },
      {
        domain: "Workshops",
        coords: [
          {
            name: "Eshwar Yadav",
            number: 8688947336,
          },
          {
            name: "Keerthan Sai",
            number: 7382232377,
          },
        ],
      },

      {
        domain: "Multimedia",
        coords: [
          {
            name: "Siddharth Saini",
            number: 9996130681,
          },
          {
            name: "Likith Kumar",
            number: 8919174545,
          },
        ],
      },
      {
        domain: "Infra",
        coords: [
          {
            name: "Abhishek Sagar",
            number: 6307010939,
          },
          {
            name: "Vatsal Khandelwal",
            number: 7023045548,
          },
        ],
      },
      {
        domain: "Proshows",
        coords: [
          {
            name: "Vaibhav Gupta",
            number: 7357466555,
          },
        ],
      },
      {
        domain: "Finance",
        coords: [
          {
            name: "Sanket Ranade",
            number: 9324473158,
          },
        ],
      },
      {
        domain: "Transport",
        coords: [
          {
            name: "Mohammed Adil",
            number: 7095175683,
          },
        ],
      },
      {
        domain: "Security",
        coords: [
          {
            name: "Chandrahaas",
            number: 8555843152,
          },
        ],
      },
      {
        domain: "Litr",
        coords: [
          {
            name: "Soumi Chakraborty",
            number: 9916904237,
          },
        ],
      },
      {
        domain: "Social Cause",
        coords: [
          {
            name: "Vedika Verma",
            number: 8210074097,
          },
        ],
      },

      {
        domain: "Culti-Biggies",
        coords: [
          {
            name: "Patlola Yagneek",
            number: 9000381333,
          },
          {
            name: "Nishita Pattanayak",
            number: 9849803210,
          },
        ],
      },
      {
        domain: "Production",
        coords: [
          {
            name: "Swapnish Sahare",
            number: 7030753158,
          },
        ],
      },
      {
        domain: "Hospitality-1",
        coords: [
          {
            name: "Jyotshna Sri",
            number: 9398010389,
          },
          {
            name: "Prashanth A",
            number: 9390234039,
          },
        ],
      },
      {
        domain: "Hospitality-2",
        coords: [
          {
            name: "Parth Singh",
            number: 9215566552,
          },
          {
            name: "Alankritha",
            number: 7382010050,
          },
        ],
      },
      {
        domain: "Techy",
        coords: [
          {
            name: "Gorle Varshit",
            number: 8309037804,
          },
          {
            name: "B Amogh",
            number: 9492608927,
          },
        ],
      },
      {
        domain: "Informals",
        coords: [
          {
            name: "Sree Prathyush Chintha",
            number: 8688229366,
          },
          {
            name: "Tisha Pantawane",
            number: 8999428103,
          },
        ],
      },
      {
        domain: "Creatives",
        coords: [
          {
            name: "Sidhardha Grandhi",
            number: 6300568214,
          },
          {
            name: "Yash Rathi",
            number: 7032514404,
          },
        ],
      },
      {
        domain: "Creatives",
        coords: [
          {
            name: "Akshith Akkenpalli",
            number: 8978514109,
          },
          {
            name: "Pranjal Desale",
            number: 9307534849,
          },
        ],
      },
      {
        domain: "Creatives",
        coords: [
          {
            name: "Likitha.S",
            number: 8328596047,
          },
          {
            name: "Nishanth Kannan",
            number: 9550820916,
          },
        ],
      },
      {
        domain: "Sponsorship",
        coords: [
          {
            name: "Aahan Jain",
            number: 8008495801,
          },
          {
            name: "Chaitanya Varun",
            number: 709507594,
          },
        ],
      },
      {
        domain: "Sponsorship",
        coords: [
          {
            name: "Chirag Jain",
            number: 9326168076,
          },
          {
            name: "Prakhar Pragya",
            number: 7549136119,
          },
        ],
      },
      {
        domain: "Sponsorship",
        coords: [
          {
            name: "Sachi Kavitake",
            number: 9511631183,
          },
          {
            name: "Sohith Kumar",
            number: 9553907594,
          },
        ],
      },
      {
        domain:'EML',
        coords: [
          {
            name:"Anushka Khare",
            number:9617915183,
          }
        ]
      }
    ];
  }

  componentDidMount() {
    AOS.init();
    // this.props.setLoaded(false)
    // window.addEventListener('load',()=>{
    //   this.props.setLoaded(true)
    // })
  }

  // componentWillUnmount() {
  //   window.removeEventListener('load',()=>{
  //     this.props.setLoaded(true)
  //   })
  // }

  render() {
    return (
      <div className={"team"}>
        <div className={"textbox"}>
          <Header className={"heading"}>THE TEAM</Header>
        </div>
        <HeadDetails data-aos={"fade-down"} {...this.overall_head} />
        <div className={"grid-container"}>
          {this.heads.map((item) => (
            <HeadDetails key={item.number} {...item} />
          ))}
        </div>
        <div className={"coord-container"}>
          {this.coords.map((item, index) => {
            return (
              <div
                key={index}
                data-aos={"fade-down"}
                data-aos-duration="1000"
                className={"domain-container"}
              >
                <Header as={"h3"}>{item.domain}</Header>
                {item.coords.map((coord) => {
                  return (
                    <CoordDetails
                      key={coord.name}
                      name={coord.name}
                      number={coord.number}
                    />
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default withUserContext(Team);
